/** @jsx jsx */

import { ComponentProps } from 'react';

import { Colors, Icon } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  root: ({ canAcceptPointerEvents, isBlock, size }) => css`
    display: ${isBlock ? 'block' : 'inline-block'};
    height: ${size}px;
    pointer-events: ${canAcceptPointerEvents ? undefined : 'none'};
    width: ${size}px;
  `,
};

type Props = Omit<ComponentProps<typeof Icon>, 'name'> & {
  name: ComponentProps<typeof Icon>['name'] | 'trigger' | 'action';
};

/**
 * An extension of Icon to be capable of rendering action and trigger icons..
 */
function ExtendedIcon(props: Props) {
  const {
    'aria-hidden': ariaHidden,
    'aria-label': ariaLabel,
    canAcceptPointerEvents,
    color,
    isBlock,
    name,
    size = 'small',
  } = props;

  if (name !== 'trigger' && name !== 'action') {
    return <Icon {...props} name={name} size={30} />;
  }

  return (
    <span
      aria-hidden={ariaHidden}
      aria-label={ariaLabel}
      css={Styles.root({ canAcceptPointerEvents, isBlock, size })}
    >
      {name === 'action' && (
        <svg fill="none" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
          <path
            clipRule="evenodd"
            d="M26.2135 27.3174V2.5H21.25V13.306H20.7143H18.3544V17.0285H20.7143H21.25V27.3174H26.2135ZM3.75 13.306H5.6113H7.97115V17.0285H5.6113H3.75V13.306ZM15.5226 17.0285H10.803V13.306H15.5226V17.0285Z"
            fill={Colors[color]}
            fillRule="evenodd"
          />
        </svg>
      )}
      {name === 'trigger' && (
        <svg fill="none" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
          <path
            clipRule="evenodd"
            d="M8.71348 13.306V2.5H3.75V27.3174H8.71348V17.0285H9.28577H11.6456V13.306H9.28577H8.71348ZM26.25 17.0285H24.3887H22.0289V13.306H24.3887H26.25V17.0285ZM19.1971 17.0285H14.4774V13.306H19.1971V17.0285Z"
            fill={Colors[color]}
            fillRule="evenodd"
          />
        </svg>
      )}
    </span>
  );
}

export default ExtendedIcon;
